import { render } from "./CpBox.vue?vue&type=template&id=2071293d&scoped=true"
import script from "./CpBox.vue?vue&type=script&lang=js"
export * from "./CpBox.vue?vue&type=script&lang=js"

import "./CpBox.vue?vue&type=style&index=0&id=2071293d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2071293d"]])

export default __exports__